export {default} from './Project';


// WEBPACK FOOTER //
// ./src/components/Project/index.js